/**
 * Public API for Drawer Component System
 * 
 * Usage:
 * import { DrawerService, DrawerRef, DrawerConfig } from '@app/shared/components/drawer';
 */

export { DrawerComponent } from './drawer.component';
export { DrawerService } from './drawer.service';
export { DrawerRef } from './drawer-ref';
export { DrawerConfig, DrawerConfigDefaults } from './drawer-config';
export { ExampleDrawerContentComponent } from './example-drawer-content.component';
